import { render } from "./moduleLoadingIcon.vue?vue&type=template&id=9280dcc0"
import script from "./moduleLoadingIcon.vue?vue&type=script&lang=js"
export * from "./moduleLoadingIcon.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__